// FALLBACK (seit B3): Die maßgebliche Phasen-Konfiguration kommt aus dem
// Backend (GET /pipeline-config/, im Django-Admin gepflegt) und wird über
// den PipelineConfigProvider bezogen. Diese Konstanten dienen nur noch als
// Startwert vor der Antwort bzw. Notnagel bei API-Fehlern — hier nichts
// mehr pflegen, Änderungen gehören in den Admin.
// „On Hold" entfällt seit B3 (Team-Entscheidung, wird nicht gebraucht).

export const PROJECT_PHASES = [
  {
    key: 'Planning', label: 'In Planung',
    next: 'Projekt starten',
    checklist: ['Vertrag unterzeichnet', 'Team & Zeitraum stehen'],
  },
  {
    key: 'In Progress', label: 'Aktiv',
    next: 'Zum Abschluss führen',
    checklist: ['Kickoff durchgeführt', 'Stundenkontingent im Blick'],
  },
  {
    key: 'Completed', label: 'Abgeschlossen',
    next: 'Zusammenarbeit auswerten',
    checklist: ['Abschlussgespräch geführt', 'Folgebedarf besprochen'],
  },
];

export const PROJECT_LOST = { key: 'Cancelled', label: 'Abgebrochen' };
